import { useState } from 'react';

import { Col, Row, Button } from 'darrius';

import { triggerEvent } from '../../../utils/triggerEvent';

import { CIMessageDialog, Dialog } from '../../../components';

import { IUserTransformationReturn } from '../../../modules/profile/shared/transformations/user/@interfaces';

import styles from './AdsMessageDialog.module.scss';

interface IAdsMessageDialogProps {
  adsMessageDialogData: {
    requestId: string;
    user: IUserTransformationReturn;
    isUserCliAuthenticated: boolean;
    isSentMessage: boolean;
  };
  isSentMessageSuccess: boolean;
  slug?: string;
  requestUuid: string;
}

export function AdsMessageDialog({
  adsMessageDialogData,
  requestUuid,
}: IAdsMessageDialogProps) {
  const { isSentMessage, isUserCliAuthenticated, requestId, user } =
    adsMessageDialogData;
  const [isSentMessageSuccess, setIsSentMessageSuccess] = useState(false);

  const [isMessageDialogOpen, setIsMessageDialogOpen] = useState(false);

  const messageDialogText = {
    messageDescription:
      'Use esse espaço para adicionar o corpo do texto do seu modal e preenchê-lo com as informações mais essenciais.',
    successTitle: 'Mensagem enviada!',
    successDescription: `Assim que ${user.name} visualizar a sua mensagem, ele poderá te responder através do nosso chat. No caso de o profissional não estar disponível no momento, notificaremos por este canal.`,
  };

  function handleOpenMessageDialog() {
    setIsMessageDialogOpen(
      (prevIsMessageDialogOpen) => !prevIsMessageDialogOpen
    );
  }

  function onSendMessage(isSentMessage: boolean) {
    setIsSentMessageSuccess(isSentMessage);
  }

  const TRACK_EVENT_NAME =
    'instant-match_service-sale-ads__cta-message-need-help-choosing';
  const TRACK_ACTION = 'click';

  function trackAdsMessageButton(label: string, eventName: string) {
    triggerEvent(eventName, {
      requestId: user.requestId,
      profileId: user.id,
      label: label,
      action: TRACK_ACTION,
      value: user.partner.price ? user.partner.price : null,
    });
  }

  function renderAdsMessageDialog() {
    if (isUserCliAuthenticated) {
      return (
        <div className="no-margins">
          <Row
            className={`${styles['ads-instant-match-buttons']} center-sm start-md no-margins`}
          >
            <Col className="buttons">
              <Dialog.Root
                onOpenChange={handleOpenMessageDialog}
                open={isMessageDialogOpen}
              >
                <div className={styles['ads-instant-match-buttons__chat']}>
                  <Dialog.Trigger asChild>
                    <Button.Root
                      disabled={isSentMessage || isSentMessageSuccess}
                      variation="clear"
                      onClick={() =>
                        trackAdsMessageButton(
                          'need_help_choosing',
                          TRACK_EVENT_NAME
                        )
                      }
                    >
                      <Button.Icon name="MdOutlineChat" size={18} />
                      Preciso de ajuda para escolher
                    </Button.Root>
                  </Dialog.Trigger>
                </div>
                <CIMessageDialog
                  user={user}
                  avatar={user.avatar}
                  name={user.name}
                  category={user.description}
                  onSendMessage={onSendMessage}
                  isSentMessageSuccess={isSentMessageSuccess}
                  isMessageDialogOpen={isMessageDialogOpen}
                  requestUuid={requestUuid}
                  messageDescription={messageDialogText.messageDescription}
                  successTitle={messageDialogText.successTitle}
                  successDescription={messageDialogText.successDescription}
                />
              </Dialog.Root>
            </Col>
          </Row>
        </div>
      );
    }
  }

  return <>{renderAdsMessageDialog()}</>;
}
